import httpService from "./httpService";
import utils from "./utils";

export default {

  count() {
    return httpService.get("/vbNotification/count");
  },

  findAll(pageable) {
    pageable = utils.initPageableParams(pageable);
    return httpService.get("/vbNotification", {params: pageable});
  },

  countUnSeen() {
    return httpService.get("/vbNotification/countUnSeen", null);
  },

  maskAsSeen(item) {
    return httpService.post("/vbNotification/maskAsRead/" + item.notificationDetailId);
  },
  update(form) {
    return httpService.post("/vbDocUserNotify/update", form);
  },
  fineOne(form) {
    return httpService.get("/vbDocUserNotify/fineOne", {params: form});
  }
}



// WEBPACK FOOTER //
// ./src/services/vbNotificationService.js